<template>
    <div>
        <!-- Desktop template -->
        <div class="row align-items-center pt-2 footer--ticket d-none d-md-flex">
            <div class="col flex-2" :class="typeClass()">
                <span class="footer--ticket--type">{{ product.pur_type | capitalize }}</span>
                <span class="footer--ticket--category">{{product.title}}</span>
                <span class="footer--ticket--date"> -  Fecha: {{product.start_date}}</span>
            </div>

            <div class="col footer--ticket--quantity--container d-flex no-wrap">
                <button class="flex--body--minus--button" @click="decrease(product, 'cart')">
                    <icon-base :view-box-height="24"
                               :view-box-width="24"
                               :height="20"
                               :width="20"
                               :min-height="88.8"
                               :min-width="-87"
                               :icon-color="'#ffffff'">
                        <minus-icon/>
                    </icon-base>
                </button>
                <span class="flex--body--quantity">{{ product.quantity }}</span>
                <button class="flex--body--plus--button" @click="increase(product, 'cart')">
                    <icon-base :view-box-height="24"
                               :view-box-width="24"
                               :height="20"
                               :width="20"
                               :min-height="89"
                               :min-width="-87"
                               :icon-color="'#ffffff'">
                        <plus-icon/>
                    </icon-base>
                </button>
            </div>

            <!--<div class="col-auto footer&#45;&#45;ticket&#45;&#45;from flex-2">-->
                <!--Cargas para ser usadas durante la <strong>temporada 2018</strong>-->
            <!--</div>-->

            <div class="col footer--ticket--price">
                {{ subtotal(product) | currency }}
            </div>

            <div class="col footer--ticket--remove">
                <button class="btn btn-link" @click="remove(product)">
                    <icon-base :view-box-height="512"
                               :view-box-width="512"
                               :width="30"
                               icon-color="#FF5252"
                               :height="30">
                        <circle-times-icon/>
                    </icon-base>
                </button>
            </div>
        </div>

        <!-- Mobile template -->
        <div class="row align-items-baseline pt-2 footer--ticket d-flex d-md-none">
            <div class="col" :class="typeClass()">
                <span class="footer--ticket--type">{{ product.pur_type | capitalize }}</span>
                <span class="footer--ticket--category">{{product.title}}</span>
            </div>

            <div class="w-100"></div>

            <div class="col footer--ticket--quantity--container d-flex no-wrap align-items-baseline">
                <button class="flex--body--minus--button" @click="decrease(product)">
                    <icon-base :view-box-height="24"
                               :view-box-width="24"
                               :height="20"
                               :width="20"
                               :min-height="88.8"
                               :min-width="-87"
                               :icon-color="'#ffffff'">
                        <minus-icon/>
                    </icon-base>
                </button>
                <span class="flex--body--quantity">{{ product.quantity }}</span>
                <button class="flex--body--plus--button" @click="increase(product)">
                    <icon-base :view-box-height="24"
                               :view-box-width="24"
                               :height="20"
                               :width="20"
                               :min-height="89"
                               :min-width="-87"
                               :icon-color="'#ffffff'">
                        <plus-icon/>
                    </icon-base>
                </button>
            </div>

            <div class="col-auto footer--ticket--from flex-2 d-none d-md-block">
                Cargas para ser usadas desde el
                <strong>17 de julio hasta el 24 de julio</strong>
            </div>

            <div class="col footer--ticket--price text-center">
                {{ subtotal(product) | currency }}
            </div>

            <div class="col footer--ticket--remove text-center">
                <button class="btn btn-link" @click="remove(product)">
                    <icon-base :view-box-height="512"
                               :view-box-width="512"
                               :width="30"
                               icon-color="#FF5252"
                               :height="30">
                        <circle-times-icon/>
                    </icon-base>
                </button>
            </div>

            <div class="w-100"></div>

            <!--<div class="col-auto footer&#45;&#45;ticket&#45;&#45;from flex-2">-->
                <!--Cargas para ser usadas desde el-->
                <!--<strong>17 de julio hasta el 24 de julio</strong>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import cartMixin from '../mixins/cartMixin';

    export default {
        props: {
            index: {
                type: Number,
                default() {
                    return 0
                }
            },

            product: {
                type: Object,
                default() {
                    return {}
                }
            }
        },

        mixins: [cartMixin],

        computed: {},

        methods: {
            isFlex() {
                return this.product.pur_type === 'FLEX';
            },

            typeClass() {
                switch (this.product.pur_type) {
                    case 'FLEX':
                        return ['c-blue'];
                    case 'HOY':
                        return ['c-light-blue'];
                    case 'PROMO':
                        return ['c-gray'];
                    default:
                        return ['c-yellow'];
                }
            },

            subtotal(product) {
                return product.price;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/CartTicket.vue